import React, { Component } from 'react';

class ProgressBarSVG extends Component {
  render(){
    const votes = Math.round(parseFloat(this.props.votes)),
      totalVotes = Math.round(parseFloat(this.props.totalVotes));

    return (
    <div>
      <strong style={{color:this.props.winner ? '#ff4d31' : 'inherit'}}>
        {this.props.title}
      </strong>
      <br />
      <svg width={this.props.width} height={this.props.height}>
        <rect
          width={this.props.width}
          height={this.props.height}
          rx={this.props.height / 2}
          ry={this.props.height / 2}
          fill={this.props.winner ? '#ffd6cd' : '#f6f6f6'}
        />
        <rect
          width={this.props.width * (votes / totalVotes)}
          height={this.props.height}
          rx={this.props.height / 2}
          ry={this.props.height / 2}
          fill={this.props.winner ? '#ff4d31' : '#dddddd'}
        />
      </svg>
      &nbsp;&nbsp;&nbsp;&nbsp;
      <strong style={{color:this.props.winner ? '#ff4d31' : 'black'}}>
        {(this.props.displayPercent).toFixed(0)}%
      </strong>
      &nbsp;&nbsp;&nbsp;&nbsp;
      <span style={{color:this.props.winner ? '#ff4d31' : 'black'}}>
        {(this.props.votes || 0).toLocaleString()}
      </span>
      {this.props.correct && (
        <strong style={{color:'#4ead5e'}}>&nbsp;&nbsp;&nbsp;&nbsp;Correct</strong>
      )}
    </div>
    )
  }
}

ProgressBarSVG.defaultProps = {
  shouldRoundUp:false,
  title:'Choice Title',
  width:300,
  height:15,
  totalVotes:100,
  votes:0,
  winner:false,
  correct:false,
  displayPercent:50
}

export default ProgressBarSVG;



// WEBPACK FOOTER //
// ./src/shared/components/ProgressBarSVG/ProgressBarSVG.js